import { render, staticRenderFns } from "./publist.vue?vue&type=template&id=2626e0f2&"
import script from "./publist.vue?vue&type=script&lang=js&"
export * from "./publist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports